module.exports = __webpack_public_path__ + "static/fonts/SCDream3.b96c10d.woff";